


















































































































import Vue, { PropType } from 'vue'
import {
  apiSearchMartSearchFindSearchFilter,
  ApiSearchMartSearchFindSearchFilterResponse,
} from '@/api'
import { cloneDeepFast, flatten, mapValues, values } from 'vtils'

type OrderBy = 'none' | 'price' | 'sales'
type OrderType = 'none' | 'desc' | 'asc'

type OrderItem = {
  orderBy: OrderBy
  label: string
  noOrderType?: boolean
}

type ModelValue = {
  orderBy: OrderBy
  orderType: OrderType
  available?: boolean
  discounted?: boolean
  minPrice?: number
  maxPrice?: number
  params?: Record<string, string[]>
}

export default Vue.extend({
  props: {
    value: {
      type: Object as PropType<ModelValue>,
      required: true,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    searchId: {
      type: String,
      default: '',
    },
    full: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    list: [
      {
        orderBy: 'none',
        label: '综合',
        noOrderType: true,
      },
      {
        orderBy: 'price',
        label: '价格',
      },
      {
        orderBy: 'sales',
        label: '销量',
      },
    ] as OrderItem[],
    filterPopupVisible: false,
    tempValue: {} as ModelValue,
    paramsData: [] as ApiSearchMartSearchFindSearchFilterResponse,
  }),

  computed: {
    filterSelected() {
      return (
        this.hasFilter &&
        (this.value.available ||
          this.value.discounted ||
          this.value.minPrice ||
          this.value.maxPrice ||
          values(this.value.params || {}).some(list => !!list.length))
      )
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.tempValue = cloneDeepFast(this.value)
      },
    },
    searchId: {
      immediate: true,
      async handler() {
        if (this.searchId) {
          this.paramsData = await apiSearchMartSearchFindSearchFilter({
            searchId: this.searchId,
          })
          this.$set(
            this.tempValue,
            'params',
            this.paramsData.reduce((res, item) => {
              ;(res as any)[item.keyName] = []
              return res
            }, {}),
          )
        }
      },
    },
  },

  methods: {
    handleItemClick(item: OrderItem) {
      const value = { ...this.tempValue }
      value.orderType = item.noOrderType
        ? 'none'
        : value.orderBy === item.orderBy
        ? value.orderType === 'none' || value.orderType === 'asc'
          ? 'desc'
          : 'asc'
        : 'desc'
      value.orderBy = item.orderBy
      this.$emit('input', value)
    },

    handleDiscountClick(item: 'available' | 'discounted') {
      const value = { ...this.tempValue }
      value[item] = !value[item]
      value[item === 'available' ? 'discounted' : 'available'] = false
      this.tempValue = value
    },

    handleParamClick(group: string, value: string) {
      const list = this.tempValue.params![group]
      const foundIndex = list.indexOf(value)
      if (foundIndex !== -1) {
        this.$delete(list, foundIndex)
      } else {
        list.push(value)
      }
    },

    handleResetClick() {
      this.tempValue = {
        ...this.tempValue,
        available: false,
        discounted: false,
        minPrice: undefined,
        maxPrice: undefined,
        params: mapValues(this.tempValue.params || {}, () => []),
      }
    },

    handleConfirmClick() {
      ;(this as any).$track.push({
        name: '筛选确定',
        id: '6b14f3d2-a077-4fc4-8a9e-2eca2186036c',
        content: [
          this.tempValue.available && '仅看有货',
          this.tempValue.discounted && '优惠',
          this.tempValue.minPrice && `最低价:${this.tempValue.minPrice}`,
          this.tempValue.maxPrice && `最高价:${this.tempValue.maxPrice}`,
          ...flatten(values(this.tempValue.params)),
        ]
          .filter(Boolean)
          .join('|'),
      })
      this.filterPopupVisible = false
      this.$emit('input', cloneDeepFast(this.tempValue))
    },
  },
})
